import { UserSearchHistory } from '.';

export interface SearchHistoryState {
  history: UserSearchHistory[];
  loading: boolean;
}

export const SEARCH_HISTORY_ADD = 'SEARCH_HISTORY_ADD';
export const SEARCH_HISTORY_CLEAR = 'SEARCH_HISTORY_CLEAR';
export const SEARCH_HISTORY_LOADING = 'SEARCH_HISTORY_LOADING';

interface SearchHistoryAddAction {
  type: typeof SEARCH_HISTORY_ADD;
  payload: UserSearchHistory[];
}

interface SearchHistoryClearAction {
  type: typeof SEARCH_HISTORY_CLEAR;
}

interface SearchHistoryLoadingAction {
  type: typeof SEARCH_HISTORY_LOADING;
  payload: boolean;
}

export type SearchHistoryActionTypes =
  | SearchHistoryAddAction
  | SearchHistoryClearAction
  | SearchHistoryLoadingAction;
